const findComparableAppVersion = ({ appsVersions = [], app, version }) => {
  if (!app?.id || !version) {
    return undefined;
  }

  return appsVersions?.find((candidate) => candidate?.id === app.id && String(candidate?.version) === String(version));
};

export default findComparableAppVersion;
